module.exports = __webpack_public_path__ + "img/link_icon.2b895d64.svg";